import { SporteventSet } from "@gaming/srvg-classes-core";
import { Competition } from "../Competition";
import { CompetitionStage } from "../CompetitionStage";

export class Matchset extends SporteventSet {
    competitionStage: CompetitionStage;
    constructor( id:number, nr:number, competitionStage: CompetitionStage, competition:Competition, start:number, end:number ) {
        super( id, nr, competition, start, end );
        this.competitionStage = competitionStage;
    }

    getName() {
        return 'Matchday ' + this.nr; // FIXME
    }
}